/**
 * useUploadCommunityImage Hook
 * Mutation hook for uploading community images
 */

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import { uploadCommunityImage } from "../services/community.service"

interface UploadCommunityImageVariables {
  communityId: string
  file: File
}

export function useUploadCommunityImage() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ communityId, file }: UploadCommunityImageVariables) =>
      uploadCommunityImage(communityId, file),

    onSuccess: () => {
      // Invalidate community images query to refetch
      queryClient.invalidateQueries({
        queryKey: ["community"],
      })
      toast.success("Image uploaded successfully")
    },

    onError: () => {
      toast.error("Failed to upload image")
    },
  })
}
